import CreateList from "../components/CreateList";
import React from "react";

const  CreateCustomerListV2= () => {
    return (

        <div id="createCustomerListPackYourLuggage" className="container-fluid">
            <div className="container">
                <div className="row">
                    <div className="col s2"></div>
                    <div className="col s8">
                        <p id="PageTitle"> PACK YOUR LUGGAGE</p>
                    </div>
                    <div className="col s2"></div>
                </div>
            </div>
            <div className="row">
                <CreateList/>
            </div>
        </div>



    );
}

export default CreateCustomerListV2 ;